/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : checkoutActionConstants.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Madhu Gali - H175591
*
* @Date         : Oct 10, 2019
*
* @Version      : Version 1.0
*
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Feb 19, 2020
 * Description   : ASDS-2355
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
******************************************************************************/

/**
 * @author H175591
 * @description Constains constants for action creators for checkout module.
 */
const checkoutActionConstants = {
    SET_LOGGED_IN_USER_INFO: 'setLoggedInUserInfo',
    SET_USER_ACCESS_INFO: 'setUserAccessInfo',
    GET_FORGE_ACCESS_TOKEN: 'getForgeAccessToken',
    GET_PAYMETRIC_URL: 'getPaymetricURL',
    SET_PAYMETRIC_URL: 'setPaymetricURL',
    SET_SFDC_CASE_STATUS: 'setSFDCCaseStatus',
    INCREMENT_CC_LOAD_COUNT: 'incrementCount',
    RESET_CC_LOAD_COUNT: 'resetCCLoadCount',
    HAS_ERROR: 'hasError',
    SET_ASDS_ACCESS_INFO: 'setASDSAccessInfo',
    SET_ASDS_USER_ROLE: 'setASDSUserRole',
    RESET_USER_INFO: 'resetUserInfo',
}

export default checkoutActionConstants;